import React ,  {useRef , useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import fetchJson from '../lib/react-admin-loopback/fetch';
import { Button } from '@material-ui/core';
import {getYearMonthDate , addDashToDateString} from "../calendar"; 
const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    margin: {
        margin: theme.spacing(1),
      },
    textField: {
        width: '15ch',
      },
  }));

  async function reqCustomer(){

    const apiUrl = process.env.REACT_APP_API_URL;
  
    const url = `${apiUrl}/customers/?$clientType=bo`;
  
    const { json } = await fetchJson(url);
    return { 
     data : json
  };
  }
  
const Aside = (props) => {
    const classes = useStyles();
    
    const dataRef = useRef({ 
        customers: [],
      });

    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState();
    const [selectedFrom, setSelectedFrom] = useState(addDashToDateString(getYearMonthDate(new Date())));   
    const [selectedTo, setSelectedTo] = useState(addDashToDateString(getYearMonthDate(new Date())));   
    const [ customerId, setCustomerId ] = useState('A');
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            // load 정산 자료 
            setLoading(true);
            const { data }  = await reqCustomer();
            
            dataRef.current.customers = data ;
            
            setLoading(false);
          }
          catch (err) {
            setError(err);
            setLoading(false);
            // LATER server logging  
            console.error(err);
          }
        }
        fetchData();
        }, [ customerId ]);

    // dateFrom state change
    const handleFromChange = (e) => {
        setSelectedFrom(e.target.value);
      };
    // dateTo state change
    const handleToChange = (e) => {
        setSelectedTo(e.target.value);
      };

    // customerId state change
    const handleSelectChange = (e) => {
        setCustomerId(e.target.value);
    };

    // 검색 버튼 클릭
    const searchClick =() => {
        props.parentFunction(customerId , selectedFrom , selectedTo); 
    }

    return (
    <div className={classes.formControl}>
        <div>
        <Select
          id="demo-simple-select-placeholder-label"
          onChange={handleSelectChange}
          displayEmpty
          label="고객사 선택"
          className={classes.selectEmpty}
        >
          <MenuItem value="">
            <em>고객사 선택</em>
          </MenuItem>
          {dataRef.current.customers.map((ids) =>  
          <MenuItem value={ids.id}>{ids.name}</MenuItem>
          )}
        </Select>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <TextField
            id="datefrom"
            label="From"
            type="date"
            onChange={handleFromChange}
            defaultValue={selectedFrom}
            className={classes.textField}
            InputLabelProps={{
                shrink: true,
            }}
        />
        &nbsp;&nbsp;
    
        &nbsp;&nbsp;
        <TextField
            id="dateto"
            label="To"
            type="date"
            onChange={handleToChange}
            defaultValue={selectedTo}
            className={classes.textField}
            InputLabelProps={{
                shrink: true,
            }}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button onClick ={searchClick} variant="outlined">검색</Button>
        </div>

        <br />
        <div>
        <TextField
          label="취식자앱 가입자 수"
          id="standard-start-adornment1"
          className={classes.margin}
          value ={props.userCount}
          InputProps={{
            endAdornment: <InputAdornment position="end">명</InputAdornment>,
          }}
          inputProps={{
                  style: { textAlign: "right" }
                }}
            InputProps={{
                  readOnly: true,
                  
            }}
        />
        <TextField
          label="리뷰데이터 총 건수"
          id="standard-start-adornment2"
          className={classes.margin}
          value={props.reviewCount}
          InputProps={{
            endAdornment: <InputAdornment position="end">건</InputAdornment>,
          }}
          InputProps={{
            readOnly: true,
            
          }}
          inputProps={{
            style: { textAlign: "right" }
          }}
        />
        <TextField
          label="총 식수량"
          id="standard-start-adornment3"
          className={classes.margin} 
          value={props.mealCount}
          InputProps={{
            endAdornment: <InputAdornment position="end">건</InputAdornment>,
          }}
          InputProps={{
            readOnly: true,
            
          }}
          inputProps={{
            style: { textAlign: "right" }
          }}
        />
        <TextField
          label="일 평균 식수량"
          id="standard-start-adornment4"
          className={classes.margin}
          value={props.kpiCount}
          InputProps={{
            endAdornment: <InputAdornment position="end">건</InputAdornment>,
          }}
          InputProps={{
            readOnly: true,
            
          }}
          inputProps={{
            style: { textAlign: "right" }
          }}
        />
        </div>
    </div>
    )
} ;

export default Aside ;